import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { IoMdAdd } from "react-icons/io";
import { MdDeleteForever, MdVideoFile } from "react-icons/md";

const ContestBulkVideoModal = ({ show, onHide, selectedCases, onUpload, loading }) => {
  const [videoFile, setVideoFile] = useState(null);
  const videoInputRef = useRef(null);

  useEffect(() => {
    if (!show) setVideoFile(null);
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="customModal">
        <Modal.Title className="mx-auto">Upload Hearing Video</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "1.5rem" }}>
        <p className="text-muted mb-4" style={{ fontSize: "0.875rem" }}>
          Video will be uploaded for{" "}
          <strong>{selectedCases.length} selected case(s)</strong>.
          After upload, you can directly generate roznama.
        </p>

        {/* Drop zone */}
        <div
          onClick={() => videoInputRef.current.click()}
          style={{
            border: "2px dashed #ccc",
            borderRadius: "10px",
            padding: "1.5rem",
            textAlign: "center",
            cursor: "pointer",
            background: "#fafafa",
            transition: "border-color 0.2s",
          }}
          onMouseEnter={e => e.currentTarget.style.borderColor = "#f0a500"}
          onMouseLeave={e => e.currentTarget.style.borderColor = "#ccc"}
        >
          <IoMdAdd style={{ fontSize: "2rem", color: "#f0a500", marginBottom: "0.4rem" }} />
          <p style={{ margin: 0, fontSize: "0.875rem", color: "#555" }}>
            Click to select a video file
          </p>
          <p style={{ margin: 0, fontSize: "0.75rem", color: "#aaa" }}>
            MP4, AVI, MOV, MKV and other video formats
          </p>
          <input
            type="file"
            ref={videoInputRef}
            accept="video/*"
            style={{ display: "none" }}
            onChange={e => setVideoFile(e.target.files?.[0] || null)}
          />
        </div>

        {/* Selected file */}
        {videoFile && (
          <div style={{ marginTop: "1rem" }}>
            <p style={{ fontSize: "0.8rem", color: "#555", marginBottom: "0.5rem", fontWeight: 600 }}>
              Selected
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                padding: "0.5rem 0.75rem",
                background: "#f5f5f5",
                borderRadius: "8px",
                fontSize: "0.825rem",
              }}
            >
              <MdVideoFile style={{ fontSize: "1.3rem", color: "#f0a500", flexShrink: 0 }} />
              <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {videoFile.name}
              </span>
              <span style={{ color: "#aaa", fontSize: "0.75rem", flexShrink: 0 }}>
                {(videoFile.size / (1024 * 1024)).toFixed(1)} MB
              </span>
              <button
                type="button"
                onClick={() => setVideoFile(null)}
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  padding: "2px", color: "#e74c3c", flexShrink: 0, display: "flex", alignItems: "center",
                }}
                title="Remove"
              >
                <MdDeleteForever style={{ fontSize: "1.25rem" }} />
              </button>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center gap-2" style={{ borderTop: "1px solid #eee" }}>
        <Button onClick={() => onUpload({ videoFile })} className="custBtn" disabled={!videoFile || loading}>
          {loading ? "Uploading…" : `Upload${videoFile ? ` (${selectedCases.length})` : ""}`}
        </Button>
        <Button onClick={onHide} className="custBtn">Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContestBulkVideoModal;
